if (!customElements.get('media-gallery')) {
  customElements.define('media-gallery', class MediaGallery extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        liveRegion: this.querySelector('[id^="GalleryStatus"]'),
        viewer: this.querySelector('[id^="GalleryViewer"]'),
        thumbnails: this.querySelector('[id^="GalleryThumbnails"]')
      }
      this.mql = window.matchMedia('(min-width: 750px)');
      this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
      if (!this.elements.thumbnails) return;
      this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
        const trigger = mediaToSwitch.querySelector('button');
        if (!trigger) return;
        trigger.addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
      });
      if (this.dataset.desktopLayout !== 'stacked' && this.mql.matches) this.removeListSemantic();
    }

    onSlideChanged(event) {
      const activeItem = event.detail.currentElement;
      if (!activeItem) return;
      this.elements.viewer.querySelectorAll('[data-media-id]').forEach((item) => {
        item.classList.toggle('is-active', item === activeItem);
      });
      const thumbnail = this.elements.thumbnails?.querySelector(`[data-target="${ activeItem.dataset.mediaId }"]`);
      this.setActiveThumbnail(thumbnail);
      this.playActiveMedia(event.detail.currentElement);
    }

    setActiveMedia(mediaId, prepend) {
      const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${ mediaId }"]`);
      if (!activeMedia) return;
      this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
        element.classList.remove('is-active');
      });
      activeMedia.classList.add('is-active');
      this.hydrateDeferredImages(activeMedia);

      if (prepend) {
        activeMedia.parentElement.prepend(activeMedia);
        if (this.elements.thumbnails) {
          const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
          activeThumbnail.parentElement.prepend(activeThumbnail);
        }
        if (this.elements.viewer.slider) this.elements.viewer.resetPages();
      }

      this.preventStickyHeader();
      window.setTimeout(() => {
        if (this.elements.thumbnails) {
          activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
        }
        if (!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') {
          activeMedia.scrollIntoView({behavior: 'smooth'});
        }
      });
      this.playActiveMedia(activeMedia);

      if (!this.elements.thumbnails) return;
      const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
      this.setActiveThumbnail(activeThumbnail);
      if (activeThumbnail) {
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }
    }

    setActiveThumbnail(thumbnail) {
      if (!this.elements.thumbnails || !thumbnail) return;

      this.elements.thumbnails.querySelectorAll('button').forEach((element) => element.removeAttribute('aria-current'));
      thumbnail.querySelector('button').setAttribute('aria-current', true);
      if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

      this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
    }

    announceLiveRegion(activeItem, position) {
      const image = activeItem.querySelector('.product__modal-opener--image img');
      if (!image) return;
      image.onload = () => {
        this.elements.liveRegion.setAttribute('aria-hidden', false);
        this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace(
          '[index]',
          position
        );
        setTimeout(() => {
          this.elements.liveRegion.setAttribute('aria-hidden', true);
        }, 2000);
      };
      image.src = image.src;
    }

    playActiveMedia(activeItem) {
      window.pauseAllMedia();
      const deferredMedia = activeItem.querySelector('.deferred-media');
      if (!deferredMedia) return;

      deferredMedia.loadContent(false);
      this.playDeferredMedia(deferredMedia);
    }

    playDeferredMedia(deferredMedia) {
      const video = deferredMedia.querySelector('video');
      if (video) {
        video.setAttribute('playsinline', '');
        video.muted = true;
        video.controls = false;
        const playAttempt = video.play();
        if (playAttempt && typeof playAttempt.catch === 'function') {
          // A later slide change can abort playback. Never restart a hidden video.
          playAttempt.catch(() => {});
        }
        return;
      }

      const youtube = deferredMedia.querySelector('.js-youtube');
      if (youtube && youtube.contentWindow) {
        youtube.contentWindow.postMessage(
          '{"event":"command","func":"playVideo","args":""}',
          '*'
        );
        return;
      }

      const vimeo = deferredMedia.querySelector('.js-vimeo');
      if (vimeo && vimeo.contentWindow) {
        vimeo.contentWindow.postMessage('{"method":"play"}', '*');
      }
    }

    preventStickyHeader() {
      this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
      if (!this.stickyHeader) return;
      this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }

    removeListSemantic() {
      if (!this.elements.viewer.slider) return;
      this.elements.viewer.slider.setAttribute('role', 'presentation');
      this.elements.viewer.sliderItems.forEach(slide => slide.setAttribute('role', 'presentation'));
    }

    hydrateDeferredImages(container) {
      const deferredImages = container.querySelectorAll('img[data-perf-src], img[data-perf-srcset]');
      deferredImages.forEach((image) => {
        if (image.dataset.perfLoaded === '1') return;
        const srcset = image.getAttribute('data-perf-srcset');
        const src = image.getAttribute('data-perf-src');
        if (srcset) image.setAttribute('srcset', srcset);
        if (src) image.setAttribute('src', src);
        image.dataset.perfLoaded = '1';
      });
    }
  });
}
